import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TableModule } from 'primeng/table';
import { SharedModule } from '../../../shared/shared.module';
import { InputDataTableComponent } from './input-data-table.component';

@NgModule({
  imports: [
    CommonModule,
    TableModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
  ],
  declarations: [InputDataTableComponent],
  exports: [InputDataTableComponent],
})
export class InputDataTableModule {}
